/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Exclusions_EmptyInputs */

const en_us2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No exercise is out of your recommendations. When you tap “Don't recommend again” on an exercise, it shows up here.`)
};

const pt_br2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício fora das recomendações. Quando você tocar em “Não recomendar mais” num exercício, ele aparece aqui.`)
};

const es_419_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio está fuera de tus recomendaciones. Cuando toques “No recomendar más” en un ejercicio, aparecerá aquí.`)
};

const pt_pt2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício fora das recomendações. Quando tocares em “Não recomendar mais” num exercício, ele aparece aqui.`)
};

const fr_fr2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice n'est exclu de tes recommandations. Quand tu touches « Ne plus recommander » sur un exercice, il apparaît ici.`)
};

const de_de2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übung ist aus deinen Empfehlungen ausgeschlossen. Wenn du bei einer Übung auf „Nicht mehr empfehlen“ tippst, erscheint sie hier.`)
};

const it_it2_profile_exclusions_empty = /** @type {(inputs: Profile_Exclusions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio è fuori dai consigli. Quando tocchi “Non consigliare più” su un esercizio, compare qui.`)
};

/**
* | output |
* | --- |
* | "No exercise is out of your recommendations. When you tap “Don't recommend again” on an exercise, it shows up here." |
*
* @param {Profile_Exclusions_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_exclusions_empty = /** @type {((inputs?: Profile_Exclusions_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Exclusions_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_exclusions_empty(inputs)
	if (locale === "es-419") return es_419_profile_exclusions_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_exclusions_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_exclusions_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_exclusions_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_exclusions_empty(inputs)
	return en_us2_profile_exclusions_empty(inputs)
});
export { profile_exclusions_empty as "profile.exclusions_empty" }